import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
var _excluded = ["variant", "styledText", "sensitivity", "open", "onClose", "closeButtonAriaLabel", "typeIconAriaLabel", "children"];
import { jsx, jsxs } from 'react/jsx-runtime';
import { XMark } from '@box/blueprint-web-assets/icons/Fill';
import { AlertTriangle, InfoBadge, CheckmarkBadge, AlertBadge } from '@box/blueprint-web-assets/icons/Line';
import { Size5 } from '@box/blueprint-web-assets/tokens/tokens';
import * as Toast from '@radix-ui/react-toast';
import clsx from 'clsx';
import { useMemo } from 'react';
import { IconButton } from '../icon-button/icon-button.js';
import styles from './notification.module.js';

var getIcon = function getIcon(iconLabel, variant) {
  var props = {
    className: styles.typeIcon,
    'aria-label': iconLabel,
    width: Size5,
    height: Size5
  };

  switch (variant) {
    case 'error':
      return jsx(AlertBadge, _objectSpread({}, props));

    case 'success':
      return jsx(CheckmarkBadge, _objectSpread({}, props));

    case 'info':
      return jsx(InfoBadge, _objectSpread({}, props));

    case 'warning':
      return jsx(AlertTriangle, _objectSpread({}, props));
  }

  return null;
};
/**
 * A base component mounted on a page when addNotification is invoked.
 *
 * It's based on Radix-UI toast
 * * [Radix-UI link](https://www.radix-ui.com/docs/primitives/components/toast)
 *
 * **IMPORTANT**: Must be placed inside a single <b><NotificationProvider></b> singleton component provided by the app
 */


function PrivateNotificationElement(props) {
  var variant = props.variant,
      styledText = props.styledText,
      sensitivity = props.sensitivity,
      open = props.open,
      onClose = props.onClose,
      closeButtonAriaLabel = props.closeButtonAriaLabel,
      typeIconAriaLabel = props.typeIconAriaLabel,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var iconComponent = useMemo(function () {
    return getIcon(typeIconAriaLabel, variant);
  }, [typeIconAriaLabel, variant]);
  return jsx(Toast.Root, _objectSpread(_objectSpread({}, rest), {}, {
    className: clsx(styles.root, styles[variant]),
    onOpenChange: onClose,
    open: open,
    type: sensitivity,
    children: jsxs("div", {
      className: styles.container,
      children: [jsx("div", {
        className: styles.typeIconContainer,
        children: iconComponent
      }), jsxs("div", {
        className: clsx(styles.mobileContainer, _defineProperty({}, styles.withButtons, children)),
        children: [jsx("div", {
          className: styles.text,
          children: jsx(Toast.Description, {
            children: styledText
          })
        }), jsx("div", {
          className: styles.contentButtonSection,
          children: jsx("div", {
            className: styles.contentButtons,
            children: children
          })
        })]
      }), jsx("div", {
        className: styles.closeButtonSection,
        children: jsx(Toast.Close, {
          asChild: true,
          children: jsx(IconButton, {
            "aria-label": closeButtonAriaLabel,
            className: styles.closeButton,
            icon: XMark,
            onClick: onClose
          })
        })
      })]
    })
  }));
}

export { PrivateNotificationElement };